// test106
(106 && 0);
